import { composeIO } from 'react-compose-io'
import { popoverFiltroControleComissaoIO } from './PopoverFiltroControleComissao.IO'
import { PopoverFiltroControleComissaoView } from './PopoverFiltroControleComissao.View'

export const PopoverFiltroControleComissao = composeIO(PopoverFiltroControleComissaoView, popoverFiltroControleComissaoIO)
